/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import ReactQuill from "react-quill";
import { Fragment } from "react/jsx-runtime";
import { ProposalCompanyDataType } from "../../../ducks/types";
import { PhoneInput } from "react-international-phone";

export interface SummaryRef {
  getHtml: () => string;
  getFullHtml: () => string;
}

interface CoverSectionProps {
  company_name: string;
  date: string;
  responsible_manager_name: string;
  responsible_manager_phone: string;
  responsible_manager_email: string;
  client_contact_name: string;
  responsible_manager_title: string;
  proposal_title?: string;
  sections?: { key: string; label: string }[];
  coverLetter?: string; // Optional cover letter content
  proposalData: ProposalCompanyDataType | any;
  setProposalTitle: (title: string) => void;
  proposalTitle: string;
  companyLogo: string;
  propertyName: string;
}

const CoverSection = forwardRef<SummaryRef, CoverSectionProps>(
  (
    {
      company_name,
      date,
      responsible_manager_name,
      responsible_manager_phone,
      responsible_manager_email,
      client_contact_name,
      proposal_title,
      sections = [],
      proposalData,
      proposalTitle,
      companyLogo,
      propertyName,
    },
    ref
  ) => {
    const textAreaRef = useRef<any>(null);
    console.log("proposal_title", proposal_title);

    // useEffect(() => {
    //   if (proposal_title) {
    //     setProposalTitle(proposal_title || "");
    //   } else {
    //     setProposalTitle("Landscape Maintenance Proposal");
    //   }
    // }, [proposal_title, setProposalTitle]);

    const [coverPageText, setCoverPageText] = useState<string>("");

    useEffect(() => {
      const coverText = `<p> Dear ${client_contact_name}, </p>
      <p><br /></p>
      <p>
        Thank you for considering our proposal for the grounds upkeep
        at ${
          proposalData?.proposal?.potential_deal?.property?.name ?? ""
        }. We understand that you’re seeking a collaborator who can deliver top-tier horticultural expertise alongside exceptional client support. Our guiding philosophy at
        ${
          proposalData?.company?.name
        } is to Always Do What’s Right, ensuring complete peace of mind for those we serve. Your objectives will remain our focus, and we’ll consistently prioritize your needs throughout the partnership.<br/><br/>Once again, thank you for this opportunity. I’ll reach out in the coming days to answer any questions you may have.
      </p>
      <p><br /></p>
      <p>Sincerely,</p>
      <p><br /></p>
      <p> ${responsible_manager_name} </p>
      <p>
        ${proposalData?.company?.name ?? ""}
      </p>`;
      setCoverPageText(coverText);
    }, []);

    useImperativeHandle(ref, () => ({
      getHtml: () => {
        return `<div class="editableTitle">${proposalTitle}</div>
      <div class="coverText">${coverPageText}</div>`;
      },
      getFullHtml: () => {
        const titleContent =
          textAreaRef.current?.resizableTextArea?.textArea?.value || "";

        return `
      <div class="first_page">
        <div class="header">
          <div class="logo_container">
            ${
              companyLogo
                ? `<img src="${companyLogo}" class="temp_logo" alt="template logo" />`
                : ""
            }
          </div>
          <div class="proposal_title">
            <h5>${company_name}</h5>
            <h6>${date}</h6>
          </div>
        </div>
        <div class="content_footer">
          <div class="content">
            <div class="left">
              <h1><div class="editable_title">${titleContent}</div></h1>
             ${propertyName ? `<h2>For ${propertyName}</h2>` : ""}
            </div>
            <div class="right"></div>
          </div>
          <div class="footer">
            <div class="left">
              <p class="contact_title">Contact</p>
              <p class="contact_name">${responsible_manager_name}</p>
              <p class="contact_phone">${responsible_manager_phone}</p>
              <p class="contact_email">${responsible_manager_email}</p>
            </div>
            <div class="right"></div>
          </div>
        </div>
      </div>

      <div class="second_page">
        <div class="header"><h1> Table of contents </h1></div>
        <div class="content">
          <ol>
            ${sections
              .map(
                (s, idx) => `
                <li style="margin-bottom: 16px;">
                  <span class="table_title">
                    ${s.key === "Cover" ? "Cover letter" : s.key}
                  </span>
                  <span class="dots"></span>
                  <span style="float: right;">${idx + 1}</span>
                </li>
              `
              )
              .join("")}
          </ol>
        </div>
      </div>

      <div class="third_page">
        <div class="greyBorder">
          <div class="whitePanel">
            <div class="header">
              <div class="logo_container">
                ${
                  companyLogo
                    ? `<img src="${companyLogo}" class="temp_logo" alt="template logo" />`
                    : ""
                }
              </div>
            </div>
            <div class="content">
              ${coverPageText}
            </div>
          </div>
        </div>
      </div>
    `;
      },
    }));

    return (
      <Fragment>
        <div className="first_page">
          <div className="header">
            <div className="logo_container">
              {companyLogo ? (
                <img
                  src={companyLogo}
                  className="temp_logo"
                  alt="template logo"
                />
              ) : (
                <img
                  src="/images/company/no_image_grey.png"
                  className="temp_logo"
                  alt="logo"
                />
              )}
            </div>
            <div className="proposal_title">
              <h5>{company_name}</h5>
              <h6>{date}</h6>
            </div>
          </div>
          <div className="content_footer">
            <div className="content">
              <div className="left">
                <h1>
                  {/* <TextArea
                    ref={textAreaRef}
                    value={proposalTitle}
                    onChange={(e) => setProposalTitle(e.target.value)}
                    className="editable_title"
                  />{" "} */}
                  {proposalTitle}
                </h1>
                {propertyName && <h2>For {propertyName}</h2>}
              </div>
              <div className="right"> </div>
            </div>
            <div className="footer">
              <div className="left">
                <p className="contact_title">Contact</p>
                <p className="contact_name">{responsible_manager_name}</p>
                <p className="contact_phone">
                  {responsible_manager_phone ? (
                    <PhoneInput
                      className="white_color"
                      value={responsible_manager_phone}
                    />
                  ) : (
                    ""
                  )}
                </p>
                <p className="contact_email">{responsible_manager_email}</p>
              </div>
              <div className="right"> </div>
            </div>
          </div>
        </div>
        <div className="second_page">
          <div className="header">
            <h1> Table of contents </h1>
          </div>
          <div className="content">
            <ol>
              {sections.map((s, idx) => (
                <li key={idx} style={{ marginBottom: "16px" }}>
                  <span className="table_title">
                    {s.key === "Cover" ? "Cover letter" : s.key}
                  </span>{" "}
                  <span className="dots"></span>
                  <span style={{ float: "right" }}>{idx + 1}</span>
                </li>
              ))}
            </ol>
          </div>
        </div>
        <div className="third_page">
          <div className="greyBorder">
            <div className="whitePanel">
              <div className="header">
                <div className="logo_container">
                  {companyLogo ? (
                    <img
                      src={companyLogo}
                      className="temp_logo"
                      alt="template logo"
                    />
                  ) : (
                    <img
                      src="/images/company/no_image_grey.png"
                      className="temp_logo"
                      alt="logo"
                    />
                  )}
                </div>
              </div>
              <div className="content">
                <ReactQuill
                  theme="snow"
                  value={coverPageText}
                  onChange={setCoverPageText}
                  modules={{
                    toolbar: [
                      [{ header: [1, 2, false] }],
                      ["bold", "italic", "underline", "strike"],
                      [{ list: "ordered" }, { list: "bullet" }],
                      [{ align: [] }],
                      ["link", "image"],
                      ["clean"],
                    ],
                  }}
                  formats={[
                    "header",
                    "bold",
                    "italic",
                    "underline",
                    "strike",
                    "list",
                    "bullet",
                    "align",
                    "link",
                    "image",
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
);

export default CoverSection;
